import React, {useLayoutEffect} from "react";

import { IoChevronBack } from "react-icons/io5";
/*** REUSABLE COMPONENTS ***/
import FlatList from "../../../components/FlatList";
import AudioScrollableCard from "../../../components/audio/ScrollableCard/AudioScrollableCard";

/** loading */
import HomePageSkeleton from "../../../components/skeletonLoading/HomePageSkeleton";

import { useFetchAudioBookByAuthorDataQuery } from "../../../api/audioBookByAuthorPageApi";
import { useNavigate, useParams } from "react-router";

import { NotFound } from "../../error/NotFound_404";
import { useNavbar } from "../../../context/NavBarContext";

const Index = () => {
  const Navbar = useNavbar();
  const author_id = useParams().author_id;
  const { data, error, isLoading, isFetching } =
    useFetchAudioBookByAuthorDataQuery(author_id);

    console.log("data is here");
    console.log(data);

  useLayoutEffect(() => {
    Navbar.setTogglePlace(<IoChevronBack fontSize="20" />);
  }, []);

  if (isLoading) {
    return <HomePageSkeleton audio={true} />;
  }

  if (error) {
    return <NotFound error={error} />;
  }

  const BookCard = ({ item }) => {
    const navigate = useNavigate();
  
    const handleClick = () => {
      navigate(`/audio/book-series/${item.series_id}`);
    };
  
    return (
      <div 
        className="flex flex-col cursor-pointer py-3 transform transition-transform hover:scale-105"
        onClick={handleClick}
      >
        <div className="relative rounded-lg overflow-hidden shadow-lg">
          <img
            src={item.series_image}
            alt={item.series_title}
            className="w-full h-48 object-cover"
            onError={(e) => {
              e.target.src = '/placeholder-book.jpg'; // fallback image
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        </div>
        <div className="mt-2 px-1">
          <p className="text-sm  my-2 font-medium text-white  leading-tight">
            {item.series_title}
          </p>
        </div>
      </div>
    )
  }


  return (
    <>
    <div className={`grid gap-4  
            grid-cols-2
          `}>
          {data.result.series.map((item, index) => {
              const key = item.item_id || item.author_id || item.collection_id || item.id || index;
                return (
                  <BookCard
                    key={key}
                    item={item}
                    
                  />
                )
              }
            )}
    </div>
    </>
  );
};

export default Index;
